import { UserDto } from '../api/tenant/models/UserDto'
import { getProfilePicUrl } from './personUtils'

export function getUserProfilePicUrl(user: UserDto): string {
    if (user.person) {
        return getProfilePicUrl(user.person, true)
    } else {
        return '/no-profile-pic.svg'
    }
}
